
import { Component, HostListener, Inject } from '@angular/core';
import { DOCUMENT, UpperCasePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { OptimoTranslate } from '../../../shared/opt-translate/optimo-translate.pipe';
import { ClientTranslatePipe } from 'src/modules/shared/opt-translate/client-translate.pipe';

@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    standalone: true,
    imports: [UpperCasePipe, OptimoTranslate, ClientTranslatePipe]
})

export class SiteHeaderComponent {
    isScroll: boolean = false;
    
    imagePath: string = environment.ApiUrl + environment.publishFolder;

    constructor(@Inject(DOCUMENT) private document: Document) { }

    @HostListener('window:scroll', [])
    onWindowScroll() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    }
}
